module.exports = __webpack_public_path__ + "static/media/kroke.eb069d22.jpg";